'use client';

import Logo from '@/assets/icons/logo';
import { Input } from '@/components/modules';
import Button from '@/components/modules/Button/Button';
import { PasswordInput } from '@/components/modules/Input/PasswordInput';
import useLogin from '@/hooks/useLogin';
import { Alert } from 'antd';
import { Link } from 'react-router-dom';

export default function LoginForm() {
  const {
    loginData,
    isLoading,
    error,
    rememberMe,
    login,
    handleInputChange,
    handleRememberMeChange,
    clearError,
  } = useLogin();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    await login();
  };

  return (
    <div className="flex justify-center lg:justify-end ">
      <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 w-full max-w-md relative">
        <div className="absolute top-[-60px] left-0 cursor-pointer">
          <Link to="https://bs.sieng.co.kr/">
            <Alert
              message="관망 바로가기"
              type="success"
              showIcon={true}
              closable={false}
              className="cursor-pointer text-sm text-green-800 hover:bg-green-100 transition-colors duration-200 p-3"
            />
          </Link>
        </div>
        <div className="text-center mb-8">
          <Logo />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">환영합니다</h2>
          <p className="text-gray-600">물탱크 관리 대시보드에 로그인하세요</p>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4">
            <div className="flex items-center">
              <i className="ri-error-warning-line text-red-500 mr-2"></i>
              <p className="text-red-700 text-sm">{error}</p>
              <button
                type="button"
                onClick={clearError}
                className="ml-auto text-red-500 hover:text-red-700"
              >
                <i className="ri-close-line"></i>
              </button>
            </div>
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-6">
          <Input
            label="회원 ID"
            type="text"
            id="id"
            name="id"
            value={loginData.id}
            onChange={handleInputChange}
            placeholder="회원 ID를 입력하세요"
            required
            icon="ri-user-line"
          />

          <PasswordInput
            label="비밀번호"
            id="password"
            name="password"
            value={loginData.password}
            onChange={handleInputChange}
            placeholder="비밀번호를 입력하세요"
            required
            icon="ri-lock-line"
          />

          <div className="flex items-center justify-between">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => handleRememberMeChange(e.target.checked)}
                className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <span className="ml-2 text-sm text-gray-600">
                아이디 기억하기
              </span>
            </label>
            <button
              type="button"
              className="text-sm text-blue-600 hover:text-blue-800 cursor-pointer whitespace-nowrap"
            >
              비밀번호를 잊으셨나요?
            </button>
          </div>

          <Button
            loading={isLoading}
            type="submit"
            size="large"
            fullWidth={true}
          >
            {isLoading ? '로그인 중...' : '대시보드 로그인'}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            도움이 필요하신가요? {/* TODO: 고객 지원 버튼 액션 추가 */}
            <button className="text-blue-600 hover:text-blue-800 cursor-pointer whitespace-nowrap">
              고객 지원
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
